/* eslint-disable react/no-unescaped-entities */
// @flow
import React from 'react';
import { Strong } from '@finect/tabular-core/Strong';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { UnorderedList } from '@finect/tabular-core/UnorderedList';
import { AppLink } from '@finect/tabular-core/AppLink';
import { ArticleDetail, ArticleCTA, LazyPill } from '../../../components';

type Props = {
  location: Object,
  history: Object,
  toggleModal: Function
};

export const QueEs = ({ location, history, toggleModal }: Props) => {
  const redirectTo = (url: string) => {
    history.push(url);
  };

  return (
    <ArticleDetail
      location={location}
      title="¿Qué es un asesor financiero y cuáles son sus funciones?"
      redirectTo={redirectTo}
      toggleModal={toggleModal}
    >
      <Paragraph>
        Si no tienes muy claro qué es un asesor financiero y a qué se dedica, vamos a verlo para que resuelvas todas tus
        dudas.
      </Paragraph>

      <Paragraph>
        Nadie mejor para describirlo que la Asociación Europea de Asesoría y Planificación Financiera. EFPA define al
        asesor financiero de la siguiente forma:{' '}
        <Strong>
          “La persona encargada de ayudarte. Alguien con un conocimiento exhaustivo en finanzas y capaz de encontrar el
          producto que mejor se adapte a tus necesidades”
        </Strong>
        . Es decir, buscan productos financieros para ti.
      </Paragraph>

      <Paragraph>
        Pero, ¿qué actividades realizan los asesores financieros y cómo ayudan a sus clientes? En primer lugar hay que
        entender que para{' '}
        <Strong>
          ofrecer <AppLink href="/asesores">asesoramiento financiero</AppLink> hay que ser una empresa de servicios de
          inversión
        </Strong>
        . Finect no lo es, por eso no te recomendamos productos. Puede haber empresas grandes y muy pequeñas,
        unipersonales, pero siempre una empresa aprobada por la CNMV. Podemos distinguir dos tipos:
      </Paragraph>

      <ul>
        <UnorderedList>
          Un{' '}
          <Strong>
            asesor financiero en un banco u otra institución financiera establece relaciones comerciales con los
            clientes y les ofrecen productos adaptados a su perfil de riesgo
          </Strong>
          . Cuando su remuneración, en este caso la remuneración del banco, depende de las comisiones que tenga el
          producto que te proponen, es un asesor no es independiente.
        </UnorderedList>

        <UnorderedList>
          Por otro lado,{' '}
          <Strong>
            hay asesores financieros independientes que no cobran comisiones por los productos que comercializan
          </Strong>
          . Su remuneración la consiguen de una cantidad fija pagada por el cliente al que asesoran. Aunque la normativa
          MiFID II ha aumentado el peso de este tipo de asesores, este tipo suele ser menos habitual ya que el público
          prefiere no hacer un pago explícito. Pero los hay, y muy buenos.
        </UnorderedList>
      </ul>

      <ArticleCTA targetId="solicita-asesor" toggleModal={toggleModal} />

      <Paragraph>
        Los <Strong>asesores financieros</Strong> te acompañan a lo largo del tiempo, cuando los mercados suben o bajan,
        te ayudan a conseguir tus objetivos y te recomiendan productos financieros ajustados a tu perfil de riesgo.
        Acostumbran además a tener ciertas cualidades: mimbres financieros y fiscales sólidos, pero también una base
        psicológica porque, como indica EFPA, tener empatía y saber tratar al cliente resulta fundamental para la labor
        de un asesor de inversiones.
      </Paragraph>
      <LazyPill />
    </ArticleDetail>
  );
};
